
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from 'components/core/Button';

import './unitListItem.scss';

export function UnitListItem({
	className, children, onClick
}) {
	return (
		<Fragment>
			{!onClick ? (
				<div className={classnames(className, 'unit-list-item')}>
					{children}
				</div>
			) : (
				<Button
					pink
					primary={false}
					className={classnames(className, 'unit-list-item')}
					onClick={onClick}
				>
					{children}
				</Button>
			)}
		</Fragment>
	);
}

UnitListItem.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node,
	onClick: PropTypes.func,
};

export default UnitListItem;
